const DY_IDS = {
  local: '9878898',
  dev: '9878898',
  stg: '9878983',
  prod: '9878984',
};

export default DY_IDS;
